import { UserCategoryTypeBC } from '../data/models/user-category-type.model';
import { selectLoggedInUserInfo } from '../data/user.slice';
import { useAppSelector } from './useAppSelector';

export const useUserCategoryTypeBC = (): UserCategoryTypeBC | null => {
  const userInfo = useAppSelector(selectLoggedInUserInfo);
  if (!userInfo) return null;
  return userInfo.userCategoryTypeBC as UserCategoryTypeBC | null;
};
